import Repository from './Repository'

const resource = '/phone'

export default {
  async createPhoneNumber (param) {
    try {
      return await Repository.post(`${resource}/create-phone-number`, param)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getById (id, isSilent = false) {
    try {
      return await Repository.get(`${resource}/${id}`, {}, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getPhoneNumber (phone, isSilent = true) {
    try {
      return await Repository.get(`${resource}/get-by-phone/${phone}`, {}, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getListPhoneNumber (param, isSilent = false) {
    try {
      return await Repository.get(`${resource}/list-phone-number`, param, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async updatePhoneNumber (param) {
    try {
      return await Repository.post(`${resource}/update-phone-number`, param)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async deletePhoneNumber (param) {
    try {
      return await Repository.delete(`${resource}/delete-phone-account`, param)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async deleteTask (sId) {
    try {
      return await Repository.delete(`${resource}/task/${sId}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async syncContacts (params = {}, isSilent = false) {
    try {
      return await Repository.post(`${resource}/cti-list-phones/update`, params, {}, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  setErrors (e) {
    const errorCode = e.response ? e.response.status : 500
    return {
      status: false,
      errorCode: errorCode,
      data: e.response ? e.response.data : 'error',
      error: e
    }
  },
  catchError (e) {
    return e.response ? e.response.data : 'error'
  }
}
